<lib-media-message-recorder [type]="type" (mediaRecorded)="mediaRecorded($event)"></lib-media-message-recorder>

<app-icon-button 
  iconClass="white"
  [ariaLabel]="'Close'"
  class="close-dialog-button" 
  icon="x" 
  mat-dialog-close>
</app-icon-button>
